import { render, staticRenderFns } from "./OrderFormFooter.vue?vue&type=template&id=05569a9a&scoped=true&"
import script from "./OrderFormFooter.vue?vue&type=script&lang=js&"
export * from "./OrderFormFooter.vue?vue&type=script&lang=js&"
import style0 from "./OrderFormFooter.vue?vue&type=style&index=0&id=05569a9a&lang=scss&scoped=true&"
import style1 from "./OrderFormFooter.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05569a9a",
  null
  
)

export default component.exports